import Vue from 'vue';
import Vuex from 'vuex';
import UtilsService from './services/UtilsService';
import VuexPersistence from 'vuex-persist';
import Notification from 'element-ui/lib/notification';
import constantes from './utils/constantes';
import analyzeDeforestationStore from '@/modules/analise-desmatamento/store';
import i18n from './main';
import { grupos } from './utils/json/grupos';

Vue.use(Vuex);

const isEmptyOrNull = value => {
    return value == null || value.length === 0;
};

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    key: 'exportaPDF',
    restoreState: (key, storage) => {
        try {
            return JSON.parse(window.localStorage.getItem(key));
        } catch (e) {
            return {};
        }
    },
    reducer: state => ({ marcarExportarPDF: state.marcarExportarPDF }),
    filter: mutation =>
        mutation.type === 'SET_MARCAR_EXPORTAR_PDF' ||
        mutation.type === 'CLEAR_MARCAR_EXPORTAR_PDF' ||
        mutation.type === 'REMOVE_ITEM_MARCAR_EXPORTAR_PDF'
});

const vuexSession = new VuexPersistence({
    storage: window.sessionStorage,
    key: 'lotePreviewAR',
    restoreState: (key, storage) => {
        try {
            return JSON.parse(window.sessionStorage.getItem(key));
        } catch (e) {
            return {};
        }
    },
    reducer: state => ({
        territoriosLotePreviewAR: state.territoriosLotePreviewAR,
        nomeArquivoLotePreviewAR: state.nomeArquivoLotePreviewAR
    }),
    filter: mutation =>
        mutation.type === 'SET_TERRITORIOS_LOTE_PREVIEW_AR' ||
        mutation.type === 'CLEAR_TERRITORIOS_LOTE_PREVIEW_AR' ||
        mutation.type === 'SET_NOME_ARQUIVO_LOTE_PREVIEW_AR' ||
        mutation.type === 'CLEAR_NOME_ARQUIVO_LOTE_PREVIEW_AR'
});

const INITIAL_STATE = {
    carSelecionadoNaPopup: null,
    limparUltimaGeometria: null,
    usuarioLogado: null,
    filtro: {
        cliente: null,
        matricula: null,
        estados: [],
        municipios: [],
        cultura: null
    },
    abaSelecionadaAreaMonitorada: null,
    safra: null,
    dadosNovaArea: {
        contato: null,
        propriedade: null,
        dadosMonitoramento: null
    },
    abaSelecionadaRepresentante: null,
    abaSelecionadaTerritorio: null,
    territorio: {},
    isSucursal: false,
    territoryTableData: [],
    monitoramentoModal: false,
    geometriaDesenhadaAcao: {},
    marcarExportarPDF: [],
    listaMonitoramentos: [],
    processandoMonitoramento: false,
    emProcessamentoPDF: false,
    acaoEscolhida: null,
    representante: {
        id: null,
        usuario: null,
        idUsuario: null,
        nomeRazaoSocial: null,
        cpfCnpj: null,
        idCliente: null,
        email: null,
        ativo: null,
        dataCadastro: null,
        dataAtualizacao: null,
        empresas: null,
        cpfCnpjCrypt: null
    },
    showCamadaToEdit: false,
    geometriaToShow: null,
    marcarExportarNeowayPDF: [],
    emProcessamentoNeowayPDF: false,
    identificadorGeometria: null,
    carsVinculadosSocioambiental: false,
    carsVinculadosAgricola: false,
    filtroMonitoramento: {},
    culturaFiltrada: null,
    modeloPlanilhaSIG: '',
    camadasPermitidasPorUsuarioState: [],
    hasCertificado: false,
    responsePreAnalisePF: null,
    trading: null,
    embeddedMode: false,
    territoriosLotePreviewAR: [],
    nomeArquivoLotePreviewAR: null
};

export default new Vuex.Store({
    modules: {
        analyzeDeforestationStore
    },
    state: Object.assign({}, INITIAL_STATE),

    getters: {
        filtro: state => state.filtro,

        isFiltering: state =>
            !isEmptyOrNull(state.filtro.cliente) ||
            !isEmptyOrNull(state.filtro.matricula) ||
            !isEmptyOrNull(state.filtro.estados) ||
            !isEmptyOrNull(state.filtro.municipios) ||
            !isEmptyOrNull(state.filtro.diretoriasNegocios),

        culturaSelecionada: state => state.filtro.cultura,

        abaSelecionadaAreaMonitorada: state =>
            state.abaSelecionadaAreaMonitorada,

        abaSelecionadaRepresentante: state =>
            state.abaSelecionadaAreaMonitorada,

        abaSelecionadaTerritorio: state => state.abaSelecionadaAreaMonitorada,

        isViewingAreaMonitorada: state =>
            state.abaSelecionadaAreaMonitorada != null,

        safras: state => state.safra.filter(s => !s.safrinha),

        safrinhas: state => state.safra.filter(s => s.safrinha),

        hasSafras: state => state.safra !== null,

        territorioData: state => state.territorio,

        isSucursal: state => state.isSucursal,

        territoryTableData: state => state.territoryTableData,

        showMonitoramentoModal: state => state.monitoramentoModal,

        geometriaDesenhadaAcao: state => state.geometriaDesenhadaAcao,

        marcarExportarPDF: state => state.marcarExportarPDF,

        marcarExportarNeowayPDF: state => state.marcarExportarNeowayPDF,

        processandoMonitoramento: state => state.processandoMonitoramento,

        listaMonitoramentos: state => state.listaMonitoramentos,

        emProcessamentoPDF: state => state.emProcessamentoPDF,

        acaoEscolhida: state => state.acaoEscolhida,

        representante: state => state.representante,

        usuarioLogado: state => state.usuarioLogado,

        showCarsVinculadosSocioambiental: state =>
            state.carsVinculadosSocioambiental,

        showCarsVinculadosAgricola: state => state.carsVinculadosAgricola,

        filtroMonitoramento: state => state.filtroMonitoramento,

        culturaFiltrada: state => state.culturaFiltrada,

        isAlvorada: state =>
            state.usuarioLogado.client === constantes.CLIENT_ID_ALVORADA,

        getAnyCertificado: state => state.hasCertificado,

        trading: state => state.trading,

        embeddedMode: state => state.embeddedMode,

        territoriosLotePreviewAR: state => state.territoriosLotePreviewAR,

        nomeArquivoLotePreviewAR: state => state.nomeArquivoLotePreviewAR
    },

    mutations: {
        SET_CAR_SELECIONADO_NA_POPUP: (state, carSelecionadoNaPopup) => {
            state.carSelecionadoNaPopup = carSelecionadoNaPopup;
        },

        SET_CERTIFICADO: (state, hasCertificado) => {
            state.hasCertificado = hasCertificado;
        },

        SET_IS_SUCURSAL: (state, isSucursal) => {
            state.isSucursal = isSucursal;
        },

        RESET_IS_SUCURSAL: state => {
            state.isSucursal = false;
        },

        SET_FILTRO: (state, filtro) => {
            state.filtro = filtro;
        },

        RESET_FILTRO: state => {
            state.filtro = INITIAL_STATE.filtro;
        },

        SET_CULTURA_SELECIONADA(state, culturaSelecionada) {
            state.filtro.cultura = culturaSelecionada;
        },

        SET_ABA_AREA_MONITORADA(state, aba) {
            state.abaSelecionadaAreaMonitorada = aba;
        },

        SET_SAFRA(state, safra) {
            state.safra = safra;
        },

        SET_DADOS_NOVA_AREA(state, dados) {
            state.dadosNovaArea = Object.assign(state.dadosNovaArea, dados);
        },

        SET_RESPONSE_PRE_ANALISE_PF: (state, responsePreAnalisePF) => {
            state.responsePreAnalisePF = responsePreAnalisePF;
        },

        SET_USUARIO_LOGADO(state, usuario) {
            state.usuarioLogado = usuario;
            sessionStorage.setItem(
                'dadosUsuario',
                usuario ? JSON.stringify(usuario) : null
            );
        },

        UPDATE_USUARIO_LOGADO_AMBIENTE(state, novoAmbiente) {
            state.usuarioLogado.ambienteLogado = novoAmbiente;
        },

        SET_ABA_REPRESENTANTE(state, aba) {
            state.abaSelecionadaRepresentante = aba;
        },

        SET_ABA_TERRITORIO(state, aba) {
            state.abaSelecionadaTerritorio = aba;
        },

        SET_TERRITORIO(state, territorio) {
            state.territorio = territorio;
        },

        RESET_TERRITORIO: state => {
            state.territorio = INITIAL_STATE.territorio;
        },

        SET_TERRITORY_TABLE_DATA: (state, territoryTableData) => {
            state.territoryTableData.push(territoryTableData);
        },

        SET_SHOW_CAMADA_TO_EDIT: (
            state,
            { showCamadaToEdit, geometriaToShow, identificadorGeometria }
        ) => {
            state.showCamadaToEdit = showCamadaToEdit;
            state.geometriaToShow = geometriaToShow;
            state.identificadorGeometria = identificadorGeometria;
        },

        CLEAR_TERRITORY_TABLE_DATA: state => {
            state.territoryTableData = [];
        },

        REMOVE_ITEM_TERRITORY_TABLE_DATA: (state, payload) => {
            state.territoryTableData = state.territoryTableData.filter(
                (value, index) => {
                    if (index !== payload) {
                        return value;
                    }
                }
            );
        },

        CHANGE_MONITORAMENTO_MODAL: state => {
            state.monitoramentoModal = !state.monitoramentoModal;
        },

        ATUALIZA_LISTA_PROCESSAMENTO_MONITORAMENTO: (
            state,
            listaMonitoramentos
        ) => {
            state.listaMonitoramentos = listaMonitoramentos;
        },

        REPLACE_TERRITORY_TABLE_DATA: (state, editedTerritoryTableData) => {
            state.territoryTableData = state.territoryTableData.map(
                territorio => {
                    if (
                        territorio.identificadorGeometria ===
                        editedTerritoryTableData.identificadorGeometria
                    ) {
                        return {
                            ...territorio,
                            ...editedTerritoryTableData
                        };
                    }
                    return territorio;
                }
            );
        },

        SET_GEOMETRIA_DESENHADA_ACAO: (state, geometria) => {
            state.geometriaDesenhadaAcao = { ...geometria };
        },

        RESET_GEOMETRIA_DESENHADA_ACAO: (state, geometria) => {
            state.geometriaDesenhadaAcao = {
                ...INITIAL_STATE.geometriaDesenhadaAcao
            };
        },

        SET_MARCAR_EXPORTAR_PDF: (state, marcarExportarPDF) => {
            if (state.emProcessamentoPDF) {
                Notification.warning({
                    message:
                        'A exportação de documentos está em processamento. Aguarde!'
                });
                return;
            }

            if (state.marcarExportarPDF === null) state.marcarExportarPDF = [];

            if (
                !state.marcarExportarPDF
                    .map(pdf => pdf.nome)
                    .includes(marcarExportarPDF.nome)
            ) {
                if (state.marcarExportarPDF.length < 5) {
                    state.marcarExportarPDF.push(marcarExportarPDF);
                } else {
                    Notification.warning({
                        message: 'Permitido até 5 documentos para exportação.'
                    });
                }
            } else {
                Notification.warning({
                    message: 'Documento já consta na listagem para exportação.'
                });
            }
        },
        SET_PROCESSANDO_MONITORAMENTO: (state, processandoMonitoramento) => {
            state.processandoMonitoramento = processandoMonitoramento;
        },

        SET_EM_PROCESSAMENTO_PDF: state => {
            state.emProcessamentoPDF = true;
        },

        CLEAR_MARCAR_EXPORTAR_PDF: state => {
            state.marcarExportarPDF = [];
            state.emProcessamentoPDF = false;
        },

        REMOVE_ITEM_MARCAR_EXPORTAR_PDF: (state, payload) => {
            state.marcarExportarPDF = state.marcarExportarPDF.filter(value => {
                if (value.idLista !== payload) {
                    return value;
                }
            });
            state.geometriaDesenhadaAcao = { ...INITIAL_STATE.acaoEscolhida };
        },

        SET_ACAO_ESCOLHIDA: (state, acao) => {
            state.acaoEscolhida = { ...acao };
        },

        RESET_ACAO_ESCOLHIDA: (state, acao) => {
            state.acaoEscolhida = { ...INITIAL_STATE.acaoEscolhida };
        },

        SET_REPRESENTANTE: (state, representante) => {
            state.representante = { ...representante };
        },

        SET_MARCAR_EXPORTAR_NEOWAY_PDF: (state, marcarExportarNeowayPDF) => {
            if (state.emProcessamentoNeowayPDF) {
                Notification.warning({
                    message: i18n.t(
                        'mensagens.sistema.exportacaoEmProcessamentoAguarde'
                    )
                });
                return;
            }

            if (state.marcarExportarNeowayPDF === null) {
                state.marcarExportarNeowayPDF = [];
            }

            if (
                !state.marcarExportarNeowayPDF
                    ?.map(pdf => pdf.documento)
                    .includes(marcarExportarNeowayPDF.documento)
            ) {
                if (state.marcarExportarNeowayPDF.length < 5) {
                    state.marcarExportarNeowayPDF.push(marcarExportarNeowayPDF);
                } else {
                    Notification.warning({
                        message: i18n.t(
                            'mensagens.sistema.permitidoAteCincoDocumentosParaExportacao'
                        )
                    });
                }
            } else {
                Notification.warning({
                    message: i18n.t(
                        'mensagens.sistema.documentoJaConstaNaListagemParaExportacao'
                    )
                });
            }
        },

        SET_EM_PROCESSAMENTO_NEOWAY_PDF: state => {
            state.emProcessamentoNeowayPDF = true;
        },

        REMOVE_REPRESENTANTE: state => {
            state.representante = {
                id: null,
                usuario: null,
                idUsuario: null,
                nomeRazaoSocial: null,
                cpfCnpj: null,
                idCliente: null,
                email: null,
                ativo: null,
                dataCadastro: null,
                dataAtualizacao: null,
                empresas: null,
                cpfCnpjCrypt: null
            };
        },

        CHANGE_CARS_VINCULADOS_SOCIOAMBIENTAL_MODAL: state => {
            state.carsVinculadosSocioambiental =
                !state.carsVinculadosSocioambiental;
        },

        CHANGE_CARS_VINCULADOS_AGRICOLA_MODAL: state => {
            state.carsVinculadosAgricola = !state.carsVinculadosAgricola;
        },

        SET_FILTRO_MONITORAMENTO: (state, filtroMonitoramento) => {
            state.filtroMonitoramento = filtroMonitoramento;
        },

        RESET_FILTRO_MONITORAMENTO: state => {
            state.filtroMonitoramento = INITIAL_STATE.filtroMonitoramento;
        },
        SET_CULTURA_FILTRADA: (state, culturaFiltrada) => {
            state.culturaFiltrada = culturaFiltrada;
        },

        RESET_CULTURA_FILTRADA: state => {
            state.culturaFiltrada = INITIAL_STATE.culturaFiltrada;
        },
        SET_MODELO_PLANILHA_SIG: (state, modeloPlanilhaSIG) => {
            state.modeloPlanilhaSIG = modeloPlanilhaSIG;
        },
        SET_CAMADAS_POR_USUARIO: (state, camadasPermitidasPorUsuarioState) => {
            state.camadasPermitidasPorUsuarioState =
                camadasPermitidasPorUsuarioState;
        },
        SET_TERRITORIO_DATA(state, payload) {
            state.territorioData = {
                areaEmMonitoramento: null,
                areaEmMonitoramentoId: null,
                areaHa: null,
                arquivosTerritorio: null,
                ativo: null,
                cars: null,
                centroide: null,
                certificacoes: null,
                codigoVega: null,
                comercializacoes: null,
                dataAtualizacao: null,
                dataAtualizacaoFormatada: null,
                dataCadastro: null,
                dataCadastroFormatada: null,
                departamentoNome: null,
                diagnosticoSocioambiental: null,
                distritoNome: null,
                estadoSigla: null,
                finca: null,
                geometria: null,
                id: null,
                idCliente: null,
                informacaoAgricolaPY: null,
                informacoesAgricolas: null,
                internacional: null,
                localidade: null,
                localidades: null,
                municipio: null,
                municipioNome: null,
                nome: null,
                padron: null,
                provincia: null,
                renspa: null,
                representantes: null,
                sobrePosicaoOutput: null,
                totalCARs: null,
                totalRepresentantes: null,
                usuario: null,
                value: ''
            };
            state.territorio = state.territorioData;
        },

        SET_EMBEDDED_MODE: (state, value) => {
            state.embeddedMode = value;
        },

        SET_TERRITORIOS_LOTE_PREVIEW_AR: (state, territorios) => {
            state.territoriosLotePreviewAR = territorios;
        },

        CLEAR_TERRITORIOS_LOTE_PREVIEW_AR: state => {
            state.territoriosLotePreviewAR = [];
        },

        SET_NOME_ARQUIVO_LOTE_PREVIEW_AR: (state, nome) => {
            state.nomeArquivoLotePreviewAR = nome;
        },

        CLEAR_NOME_ARQUIVO_LOTE_PREVIEW_AR: state => {
            state.nomeArquivoLotePreviewAR = null;
        },

        SET_TRADING: state => {
            const groupName = JSON.parse(
                sessionStorage.getItem('dadosUsuario')
            ).nameGroup;
            const trading = grupos.find(grupo =>
                groupName.toLowerCase().includes(grupo.toLowerCase())
            );
            state.trading = trading ? trading.toUpperCase() : null;
        }
    },

    actions: {
        setCarSelecionadoNaPopup({ commit }, carSelecionadoNaPopup) {
            commit('SET_CAR_SELECIONADO_NA_POPUP', carSelecionadoNaPopup);
        },

        setIsSucursal({ commit }, isSucursal) {
            commit('SET_IS_SUCURSAL', isSucursal);
        },

        resetIsSucursal({ commit }) {
            commit('RESET_IS_SUCURSAL');
        },

        filtrar: ({ commit }, filtro) => {
            commit('SET_FILTRO', filtro);
        },

        limparFiltro: ({ commit }) => {
            commit('RESET_FILTRO');
        },

        fetchSafra: async ({ commit }) => {
            const safra = await UtilsService.getSafrasVigentes();
            commit('SET_SAFRA', safra.data);
        },

        setResponsePreAnalisePF({ commit }, responsePreAnalisePF) {
            commit('SET_RESPONSE_PRE_ANALISE_PF', responsePreAnalisePF);
        },

        setMarcarExportarNeoway_PDF({ commit }, marcarExportarNeowayPDF) {
            commit('SET_MARCAR_EXPORTAR_NEOWAY_PDF', marcarExportarNeowayPDF);
        },

        removeMarcarExportarNeoway_PDF({ commit }, marcarExportarNeowayPDF) {
            commit(
                'REMOVE_ITEM_MARCAR_EXPORTAR_NEOWAY_PDF',
                marcarExportarNeowayPDF
            );
        },

        clearMarcarExportarNeoway_PDF({ commit }, marcarExportarNeowayPDF) {
            commit('CLEAR_MARCAR_EXPORTAR_NEOWAY_PDF', marcarExportarNeowayPDF);
        },

        setEmProcessamentoNeoway_PDF({ commit }) {
            commit('SET_EM_PROCESSAMENTO_NEOWAY_PDF');
        },

        setDadosNovaArea({ commit }, dados) {
            commit('SET_DADOS_NOVA_AREA', dados);
        },

        setUsuarioLogado({ commit }, dadosUsuario) {
            commit('SET_USUARIO_LOGADO', dadosUsuario);
        },

        updateUsuarioLogadoAmbiente({ commit }, novoAmbiente) {
            commit('UPDATE_USUARIO_LOGADO_AMBIENTE', novoAmbiente);
        },

        setAbaRepresentante({ commit }, aba) {
            commit('SET_ABA_REPRESENTANTE', aba);
        },

        setAbaTerritorio({ commit }, aba) {
            commit('SET_ABA_TERRITORIO', aba);
        },

        setTerritorio({ commit }, territorio) {
            commit('SET_TERRITORIO', territorio);
        },

        clearTerritorio({ commit }) {
            commit('RESET_TERRITORIO');
        },

        addListaProcessamentoMonitoramento({ commit }, listaMonitoramentos) {
            commit(
                'ATUALIZA_LISTA_PROCESSAMENTO_MONITORAMENTO',
                listaMonitoramentos
            );
        },

        limparListaProcessamentoMonitoramento({ commit }) {
            commit('ATUALIZA_LISTA_PROCESSAMENTO_MONITORAMENTO', []);
        },

        setShowCamadaToEdit(
            { commit },
            { showCamadaToEdit, geometriaToShow, identificadorGeometria }
        ) {
            commit('SET_SHOW_CAMADA_TO_EDIT', {
                showCamadaToEdit,
                geometriaToShow,
                identificadorGeometria
            });
        },

        setTerritoryTableData({ commit }, territoryTableData) {
            commit('SET_TERRITORY_TABLE_DATA', territoryTableData);
        },

        removeTerritoryTableData({ commit }, territoryTableData) {
            commit('REMOVE_ITEM_TERRITORY_TABLE_DATA', territoryTableData);
        },

        clearTerritoryTableData({ commit }, territoryTableData) {
            commit('CLEAR_TERRITORY_TABLE_DATA', territoryTableData);
        },

        changeShowMonitoramentoModal({ commit }) {
            commit('CHANGE_MONITORAMENTO_MODAL');
        },

        replaceTerritoryTableData({ commit }, territoryTableData) {
            commit('REPLACE_TERRITORY_TABLE_DATA', territoryTableData);
        },

        setGeometriaDesenhadaAcao({ commit }, geometria) {
            commit('SET_GEOMETRIA_DESENHADA_ACAO', geometria);
        },

        removerGeometriaDesenhadaAcao({ commit }) {
            commit('RESET_GEOMETRIA_DESENHADA_ACAO');
        },

        setMarcarExportar_PDF({ commit }, marcarExportarPDF) {
            commit('SET_MARCAR_EXPORTAR_PDF', marcarExportarPDF);
        },

        setprocessandoMonitoramento({ commit }, processandoMonitoramento) {
            commit('SET_PROCESSANDO_MONITORAMENTO', processandoMonitoramento);
        },

        removeMarcarExportar_PDF({ commit }, marcarExportarPDF) {
            commit('REMOVE_ITEM_MARCAR_EXPORTAR_PDF', marcarExportarPDF);
        },

        clearMarcarExportar_PDF({ commit }, marcarExportarPDF) {
            commit('CLEAR_MARCAR_EXPORTAR_PDF', marcarExportarPDF);
        },

        setEmProcessamento_PDF({ commit }) {
            commit('SET_EM_PROCESSAMENTO_PDF');
        },

        setAcaoEscolhida({ commit }, acao) {
            commit('SET_ACAO_ESCOLHIDA', acao);
        },

        removerAcaoEscolhida({ commit }) {
            commit('RESET_ACAO_ESCOLHIDA');
        },

        setRepresentante({ commit }, representante) {
            commit('SET_REPRESENTANTE', representante);
        },

        removeRepresentante({ commit }) {
            commit('REMOVE_REPRESENTANTE');
        },

        changeShowCarsVinculadosSocioambientalModal({ commit }) {
            commit('CHANGE_CARS_VINCULADOS_SOCIOAMBIENTAL_MODAL');
        },

        changeShowCarsVinculadosAgricolaModal({ commit }) {
            commit('CHANGE_CARS_VINCULADOS_AGRICOLA_MODAL');
        },

        setfiltroMonitoramento: ({ commit }, filtro) => {
            commit('SET_FILTRO_MONITORAMENTO', filtro);
        },

        limparFiltroMonitoramento: ({ commit }) => {
            commit('RESET_FILTRO_MONITORAMENTO');
        },

        setCulturaFiltrada: ({ commit }, culturaFiltrada) => {
            commit('SET_CULTURA_FILTRADA', culturaFiltrada);
        },

        limparCulturaFiltrada: ({ commit }) => {
            commit('RESET_CULTURA_FILTRADA');
        },
        setModeloPlanilhaSig({ commit }, modeloPlanilhaSig) {
            commit('SET_MODELO_PLANILHA_SIG', modeloPlanilhaSig);
        },
        setCamadasPermitidasPorUsuario(
            { commit },
            camadasPermitidasPorUsuarioState
        ) {
            commit('SET_CAMADAS_POR_USUARIO', camadasPermitidasPorUsuarioState);
        },
        setCertificado({ commit }, hasCertificado) {
            commit('SET_CERTIFICADO', hasCertificado);
        },
        limparTerritorioData({ commit }) {
            commit('SET_TERRITORIO_DATA', null);
        },
        limparCamadasPermitidasPorUsuario({ commit }) {
            commit('SET_CAMADAS_POR_USUARIO', []);
        },
        setTrading({ commit }) {
            commit('SET_TRADING');
        },
        setEmbeddedMode({ commit }, value) {
            commit('SET_EMBEDDED_MODE', value);
        },

        setTerritoriosLotePreviewAR({ commit }, territorios) {
            commit('SET_TERRITORIOS_LOTE_PREVIEW_AR', territorios);
        },

        clearTerritoriosLotePreviewAR({ commit }) {
            commit('CLEAR_TERRITORIOS_LOTE_PREVIEW_AR');
        },

        setNomeArquivoLotePreviewAR({ commit }, nome) {
            commit('SET_NOME_ARQUIVO_LOTE_PREVIEW_AR', nome);
        },

        clearNomeArquivoLotePreviewAR({ commit }) {
            commit('CLEAR_NOME_ARQUIVO_LOTE_PREVIEW_AR');
        }
    },
    plugins: [vuexLocal.plugin, vuexSession.plugin]
});
